import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('ao')) {
        let id = searchParams.get('ao');
        let element = document.getElementById(id);
        if (element) {
            element.scrollIntoView();
            OpenAccordionItem(element);
        }
    }

    window.addEventListener("hashchange", (e) => {
        let target = document.getElementById(location.hash.split('#')[1]);
        if (target !== null && target.classList.contains(' accordion-item')) {
            if (!location.hash.startsWith('#-')) {
                OpenAccordionItem(target, true);
                window.location.hash = '-' + window.location.hash.split('#')[1];
            }
        }

    });
}

function OpenAccordionItem(element) {
    let parent = element.closest('[paws-component="noss-accordion"]');
    if (element.querySelector('[data-bs-parent]')) {
        // single open
        let elements = parent.querySelectorAll('[paws-component="noss-accordionitem"]');
        elements.forEach(singleElement => {
            OpenCloseAccordionItem(singleElement, false);
        })
        OpenCloseAccordionItem(element, true);
    }
    else {
        // multi open
        OpenCloseAccordionItem(element, true);
    }
}

function OpenCloseAccordionItem(element, open) {
    let btn = element.querySelector('.accordion-button');
    let itm = element.querySelector('.accordion-collapse');

    if (open) {
        btn.classList.remove('collapsed');
        btn.setAttribute('aria-expanded', 'true');
        itm.classList.add('show');
    }
    else {
        btn.classList.add('collapsed');
        btn.setAttribute('aria-expanded', 'false');
        itm.classList.remove('show');
    }
}